import React from "react";
import { Reveal, Overline } from "./Reveal";
import { CircleDashed, ArrowRight, MapPin, Briefcase } from "lucide-react";
import { VACANCIES } from "../lib/data";

const applyForRole = (vacancy) => {
  window.dispatchEvent(new CustomEvent("apply-role", { detail: vacancy }));
};

export const Vacancies = () => {
  const hasRoles = VACANCIES.length > 0;

  return (
    <section id="vacancies" data-testid="vacancies" className="border-t border-line bg-surface">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36">
        <Reveal className="max-w-2xl mb-14">
          <Overline>Vacancies</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
            Open positions on the desk.
          </h2>
        </Reveal>

        {hasRoles ? (
          <div className="border-t border-line" data-testid="vacancies-list">
            {VACANCIES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.05}>
                <button
                  type="button"
                  data-testid={`vacancy-${i}`}
                  onClick={() => applyForRole(v)}
                  className="group w-full text-left grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-center py-8 border-b border-line hover:px-4 transition-all duration-500"
                >
                  <div className="md:col-span-5">
                    <h3 className="font-serif text-2xl sm:text-3xl text-bone group-hover:text-brass transition-colors">{v.title}</h3>
                    {v.blurb && <p className="text-mute text-sm mt-2 leading-relaxed max-w-md">{v.blurb}</p>}
                  </div>
                  <div className="md:col-span-3 font-mono text-[11px] uppercase tracking-[0.15em] text-mute flex items-center gap-2">
                    <MapPin size={13} className="text-brass" /> {v.location || "—"}
                  </div>
                  <div className="md:col-span-2 font-mono text-[11px] uppercase tracking-[0.15em] text-mute flex items-center gap-2">
                    <Briefcase size={13} className="text-brass" /> {v.type || "Full-time"}
                  </div>
                  <div className="md:col-span-2 flex md:justify-end">
                    <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-brass">
                      Apply <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal delay={0.05}>
            <div data-testid="vacancies-empty" className="border border-line bg-ink px-6 py-16 sm:py-24 flex flex-col items-center text-center">
              <CircleDashed size={40} className="text-brass" strokeWidth={1} />
              <h3 className="font-serif text-3xl sm:text-4xl text-bone mt-8">No Vacancies</h3>
              <p className="text-mute mt-4 max-w-md leading-relaxed">
                We have no open positions at this time. We're always interested in exceptional traders — register your interest and we'll be in touch when the right seat opens.
              </p>
              <button
                data-testid="vacancies-apply-btn"
                onClick={() => document.querySelector("#apply")?.scrollIntoView({ behavior: "smooth" })}
                className="group mt-10 inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] border border-brass text-brass px-7 py-4 hover:bg-brass hover:text-ink transition-colors"
              >
                Register your interest
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
};
